
        var result = require("!!../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js!../../../../node_modules/stylus-loader/index.js!./vars.styl");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    